export const BOX_CLASSNAME = "flex items-center border border-black px-2 py-1 leading-5 text-sm"
